import Http from '../http'

export default {

  index(filter) {
    // let search = ''
    // const {limit, page, level} = filter
    // search = `_page=${page}&_limit=${limit || 1000}&attributes.level=${level}`

    return Http.get(`/movements`, {params: {...filter}})
  },

  createFormData(part){
    let form_data = new FormData();
    const {
      name,
      status,
      modeling,
      universal_code,
      description,
      category_id,
      car_version_ids,
      main_image,
      images,
    } = movement

    form_data.append('movement[name]', name)
    form_data.append('movement[status]', status)
    form_data.append('movement[modeling]', modeling)
    form_data.append('movement[universal_code]', universal_code)
    form_data.append('movement[description]', description)
    form_data.append('movement[category_id]', category_id)

    for (let i=0; i<car_version_ids.length; i++) {
      form_data.append(`movement[car_version_ids][]`, car_version_ids[i]);
    }
    
    if (main_image){
      form_data.append('movement[main_image]', main_image);
    }

    if (images.length) {
      for (let i=0; i<images.length; i++) {
        form_data.append(`movement[images][]`, images[i]);
      }
    }

    movement = form_data

    return Http.post(`/movements`, movement)
  },
  create(movement){
    return Http.post(`/movements`, {movement: {
      ...movement,
    }})
  },

  update(movement){
    return Http.put(`/movements/${movement.id}`, {
      movement: {
        ...movement,
      },
    });
  },

  show(id) {
    return Http.get(`/movements/${id}`);
  },

  delete(id){
    return Http.delete(`/movements/${id}`)
  }

}
